// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"af11e216","476":"365e1c53","521":"67a0ead6","553":"d5d21f67","766":"04b31b96","832":"6d29b0e9","833":"32f89281","885":"518d6252"}[chunkId] + ".chunk.js";
};